import chatImg from "../assets/img/chat.svg";
import logo from "../assets/img/trini-talk-bot-big.svg";
import { Link } from "react-router-dom";
import { UserIcon } from "../components/Icons";
import useAuth from "../hooks/useAuth";
import AlertMsg from "../components/info/AlertMsg";

function ResetPassword() {
  document.title = "Restablecer Contraseña | Trini Talkbot";

  const {
    newPasswords,
    errorMsg,
    handleSubmitResetPassword,
    handleChangeNewPasswords,
  } = useAuth();

  return (
    <>
      <div className="container">
        <div className="forms-container">
          <div className="signin-signup">
            <form onSubmit={handleSubmitResetPassword} className="sign-in-form">
              <div className="text-center">
                <h2 className="titleLogin">Restablecer Contraseña</h2>
                <span style={{ color: "#ebebeb" }}>
                  Para continuar, debes introducir una nueva contraseña.
                  Asegúrate de que sea segura y fácil de recordar. Si necesitas
                  alguna asistencia adicional, escribenos a
                  soporte@trinitalkbot.com, estamos comprometidos en garantizar
                  la confidencialidad y protección de tus datos.
                </span>
              </div>
              <div>
                {errorMsg && <AlertMsg type="danger" text={errorMsg} />}
              </div>

              <div className="input-field">
                <UserIcon color="#212529" />
                <input
                  type="password"
                  placeholder="Ingresa una nueva contraseña.."
                  onChange={handleChangeNewPasswords}
                  name="password"
                  value={newPasswords.password}
                  required
                  maxLength={60}
                />
              </div>
              <div className="input-field">
                <UserIcon color="#212529" />
                <input
                  type="password"
                  placeholder="Repite la nueva contraseña.."
                  name="password2"
                  onChange={handleChangeNewPasswords}
                  value={newPasswords.password2}
                  required
                  maxLength={60}
                />
              </div>
              <button type="submit" className="btnlogin solid">
                Restablecer
              </button>
            </form>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <img
                src={logo}
                alt="trini logo"
                className="imageLogo"
                onClick={() => {
                  location.href = "https://trinitalkbot.com/";
                }}
                style={{ cursor: "pointer" }}
              />
              <p className="loginSub">
                ¿Recordaste tu contraseña? Ingresa haciendo clic aquí.
              </p>
              <Link
                to="/login"
                id="sign-in-btn"
                className="btn btnlogin transparent"
                style={{ lineHeight: "2" }}
              >
                <span>Ingresar</span>
              </Link>
            </div>
            <img src={chatImg} className="image" alt="asd" />
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
